export default __webpack_public_path__ + "static/media/LinearFunctionsImg.dafa2f67.jpg";